<div class="ecus-card" [class]="accentClass()">
  <header class="card-head">
    <div class="title-block">
      <h3>{{ title() }}</h3>
      <p>{{ subtitle() }}</p>
    </div>
  </header>

  <ng-container *ngIf="!isLoading()">
    <div class="ecu-list" *ngIf="rows().length > 0">
      <button type="button" class="ecu-row" *ngFor="let e of rows()" (click)="openEcu(e.ecuBuild)" [disabled]="e.ecuBuild == null" [attr.aria-label]="'View ' + type + ' tunings for ' + (e.ecuBuild || 'empty ECU build')">
        <div class="ecu-name">{{ e.ecuBuild == null ? 'Unknown ECU build' : (e.ecuBuild || '(Empty value)') }}</div>
        <div class="ecu-bar">
          <div class="ecu-bar-fill" [style.width.%]="e.barPct"></div>
        </div>
        <div class="ecu-count">{{ e.count | number }}</div>
      </button>
    </div>

    <div class="empty-state" *ngIf="rows().length === 0">
      <i class="bi bi-check-circle"></i>
      <p>Nothing to show</p>
    </div>

    <button type="button" class="expand-btn" (click)="showAll()" *ngIf="rows().length > 0" aria-haspopup="dialog">
      Show all
    </button>
  </ng-container>

  <div class="loading-state" *ngIf="isLoading()">
    <div class="bar-skeleton" *ngFor="let _ of [1,2,3,4,5]"></div>
  </div>
</div>
